import {CanActivate} from "@angular/router";
import {Injectable} from "@angular/core";
import {StateService} from "../../service/state";

@Injectable()
export class AdminGuard implements CanActivate {

    constructor(private state: StateService) {
    }

    canActivate() {
        return this.state.isLoggedIn();
    }
}


// WEBPACK FOOTER //
// ./src/app/components/guards/AdminGuard.ts